<template>
  <div id="app" style="padding: .5rem 16px;text-align: left;" class="vue-dpn">
    <van-pull-refresh v-model="isLoading"  @refresh="onRefresh">
      <div>
        <form action="/">
          <van-search
              v-model="keyword"
              placeholder="请输入合同号或订单号"
              show-action
              shape="round"
              @search="onSearch"
          >
            <template #action>
              <div @click="onSearch">搜索</div>
            </template>
          </van-search>
        </form>
      </div>

      <div class="pending-list" style="padding-bottom: 2rem;">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div
            class="pending-list-item"
            v-for="item in list"
            :key="item.id"
            @click="goDetail(item)"
          >
            <div class="cus-row cus-row-v-m">
              <div class="cus-row-col-12">
                <span class="ffm f-c-212120 s-28-40">
                  {{ getDisplayName(item) }}
                </span>
              </div>
            </div>
            <div style="margin-top: 0.2rem" class="in-bl-line">
              <span class="ffr f-c-757575 s-28-40" style="font-weight: bold">金额：¥{{ item.price }}</span>
            </div>

            <div class="cus-row cus-row-v-m" style="margin-top: 0.16rem">
              <div class="cus-row-col-8">
                <span class="ffr f-c-b5b5b5 s-24-33">申请时间：{{ item.created_at }}</span>
              </div>
             
            </div>

            <div class="cus-row cus-row-v-m" style="margin-top: 0rem">
              <div class="cus-row-col-8">
                <span class="ffr f-c-b5b5b5 s-24-33">付款单号：{{ item.bill_no || '-' }}</span>
              </div>
              <div class="cus-row-col-4 t-al-r">
                <span class="status-badge" :class="statusClass(item.status)">
                  <van-icon :name="statusIcon(item.status)" style="vertical-align: middle; margin-right: 4px;" />
                  {{ statusText(item.status) }}
                </span>
              </div>
            </div>

            <div
              style="
                margin-top: 0.3rem;
                margin-left: -0.3rem;
                margin-right: -0.3rem;
                border-top: 1px solid #e4e4e4;
                margin-bottom: -0.32rem;
              "
            >
              <div class="cus-row cus-row-v-m opr-line" style="color: #1889f8">
                <div class="cus-row-col-6 t-al-c" @click.stop="doCopy(item.bill_no)">
                  <div class="in-bl-v-m">
                    <img src="../assets/images/copy.png" style="width: 16px;"/>
                  </div>
                  <span class="opr-span">复制单号</span>
                </div>

                <div class="cus-row-col-6 t-al-c" @click.stop="goDetail(item)">
                  <div class="in-bl-v-m">
                    <img src="../assets/images/eyes.png" style="width: 20px;"/>
                  </div>
                  <span class="opr-span" style="color:#000000 !important;">详情</span>
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </div>
    </van-pull-refresh>
    <tar-bar @showqr="showqr"></tar-bar>
  </div>
  
</template>

<script>
import common from '@/assets/js/common'
import TarBar from "../components/PayTarBar";

export default {
  name: 'PaymentList',
  components: { TarBar },
  data () {
    return {
      isLoading: false,
      loading: false,
      finished: false,
      list: [],
      pageNo: 1,
      pageSize: 12,
      keyword: ''
    }
  },
  methods: {
    showqr(){},
    getDisplayName(item) {
      const type = Number(item.type)
      if (type === 1) {
        // 合同付款：显示收款开户名
        return item.bank_account_name || '-'
      } else if (type === 2) {
        // 报春内转/同行付款：显示供应商名称
        return item.supplier_name || '-'
      } else if (type === 3) {
        // 外币付款：显示账户名称
        return item.foreign_account_name || '-'
      }
      return '-'
    },
    doCopy(text){
      if(!text){return}
      this.$copyText(text).then(()=>{},()=>{})
    },
    statusText(s){
      const map = {1:'待审核',2:'待付款',3:'审核不通过',4:'已付款', 5:'已撤销', 6:'付款失败'}
      return map[parseInt(s)] || '-'
    },
    statusClass(s){
      const st = parseInt(s)
      if(st === 1){ return 'badge-warn' }
      if(st === 2){ return 'badge-info' }
      if(st === 3){ return 'badge-danger' }
      if(st === 4){ return 'badge-success' }
      return 'badge-info'
    },
    statusIcon(s){
      const st = parseInt(s)
      if(st === 1){ return 'clock-o' }
      if(st === 2){ return 'cash-o' }
      if(st === 3){ return 'close' }
      if(st === 4){ return 'passed' }
      return 'info-o'
    },
    onSearch(){
      this.pageNo = 1
      this.list = []
      this.finished = false
      this.loading = true
      this.onLoad()
    },
    onRefresh(){
      this.isLoading = false
      this.pageNo = 1
      this.list = []
      this.finished = false
      this.loading = true
      this.onLoad()
    },
    onLoad(){
      common.cusHttp(this, '/admin_user.php?action=payment_list', {pageNo: this.pageNo, pageSize: this.pageSize, keyword: this.keyword}, 'get').then((res)=>{
        res = JSON.parse(res.data)
        if(res.errcode === 200){
          const data = res.result.data || []
          if(data.length === 0){
            this.finished = true
            this.loading = false
            return
          }
          for(let i=0;i<data.length;i++){
            const row = data[i]
            if(!this.list.find(x=>x.id===row.id)){
              this.list.push(row)
            }
          }
          this.pageNo = this.pageNo + 1
        }
        this.loading = false
      })
    },
    goDetail(item){
      this.$router.push({ path: '/new_payment', query: { id: item.id }})
    }
  },
  mounted(){
    if( !common.getAuth() ){
      this.$router.push({ path: '/auth'})
      return
    }
    // 统一移除阻止滚动样式，并触发首屏加载
    common.removeDpnClass()
    this.loading = true
    this.onLoad()
  }
}
</script>

<style scoped>
.pending-list{ margin-bottom: 2rem; }
.pending-list-item{ margin-top: .32rem; padding: .32rem .30rem; background-color: #ffffff; border-radius: 0.16rem; border: 1px solid #e4e4e4; }
.status-badge{ display: inline-flex; align-items: center; padding: 0 .18rem; line-height: .5rem; border-radius: .25rem; font-size: .26rem; }
.badge-warn{ background: #fff7e6; color: #d46b08; }
.badge-info{ background: #e6f7ff; color: #096dd9; }
.badge-danger{ background: #fff1f0; color: #a8071a; }
.badge-success{ background: #f6ffed; color: #389e0d; }
/* 对齐 Pay.vue 的操作区样式，保证行高与点击区域一致 */
.opr-span { color: #212121; display: inline-block; vertical-align: middle; margin-left: 0.15rem; font-size: 0.24rem; line-height: 0.8rem; }
.opr-line .cus-row-col-6:nth-child(1) { border-right: 1px solid #e4e4e4; box-sizing: border-box; }
</style>


